import validate from "/www/gamefi/node_modules/nuxt/dist/pages/runtime/validate.js";
import default_45global from "/www/gamefi/middleware/default.global.ts";
import game_45global from "/www/gamefi/middleware/game.global.ts";
export const globalMiddleware = [
  validate,
  default_45global,
  game_45global
]
export const namedMiddleware = {}